"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  TIMELINE_CARD_LEFT_PADDING: 'p-left-15',
  TIMELINE_CARD_RIGHT_PADDING: 'p-right-8'
};
exports.default = _default;
module.exports = exports.default;